import { SelectedProcedureInterfaceState, initialSelectedProcedureState } from '../state/selected-procedure.state';
import { SelectedProcedureActions, ESelectedProcedureActions } from '../actions/selected-procedure.actions';

export function selectedProcedureReducer(state: SelectedProcedureInterfaceState = initialSelectedProcedureState, action: SelectedProcedureActions): SelectedProcedureInterfaceState {
  switch (action.type) {
    case ESelectedProcedureActions.UpdateSelectedProcedure: {
      document.getElementById('wrapper-content').scrollTop = 0;
      return { ...state, code: action.payload };
    }

    default:
      return initialSelectedProcedureState;
  }
};
